import { render, staticRenderFns } from "./GraduateRoster.vue?vue&type=template&id=309d6bf2&scoped=true"
import script from "./GraduateRoster.vue?vue&type=script&lang=js"
export * from "./GraduateRoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d6bf2",
  null
  
)

export default component.exports